import React from 'react';
import StepPlaceholder from './StepPlaceholder';

const PaymentMethod = () => <StepPlaceholder stepKey="payment" />;

export default PaymentMethod;
